import React from 'react';
import { Link } from 'react-router-dom';
import { Receipt, ArrowUpRight } from 'lucide-react';

// InvoicesSummaryCard — Sprint D item 3.6.
// Renders last-paid + next-due invoice. Signature-required-unsigned items
// surface at the top of the card with a red dot.

function formatMoney(cents, currency = 'USD') {
  if (cents == null) return '—';
  return (Number(cents) / 100).toLocaleString('en-US', { style: 'currency', currency });
}
function formatDate(s) { return s ? s.slice(0, 10) : '—'; }

export default function InvoicesSummaryCard({ recent }) {
  if (!recent) return null; // hidden for users without billing_access
  const { last_paid, next_due, signature_required_unsigned_count } = recent;
  return (
    <div data-testid="invoices-summary-card" className="rounded-2xl border border-white/[0.06] bg-white/[0.02] p-5">
      <div className="flex items-center gap-2 text-[10px] uppercase tracking-wider text-gray-500 mb-3">
        <Receipt className="w-3 h-3" />
        Invoices
      </div>

      {signature_required_unsigned_count > 0 && (
        <Link
          to="/portal/invoices"
          data-testid="invoices-signature-banner"
          className="block mb-3 px-3 py-2 rounded-lg bg-red-500/[0.06] border border-red-500/25 hover:bg-red-500/[0.1]"
        >
          <div className="flex items-center gap-2 text-[12px] text-red-300">
            <span className="w-2 h-2 rounded-full bg-red-400" />
            <span className="font-semibold">{signature_required_unsigned_count} unsigned invoice{signature_required_unsigned_count === 1 ? '' : 's'}</span>
            <span className="text-gray-400">· review & sign</span>
          </div>
        </Link>
      )}

      <div className="space-y-3 text-[12px]">
        {last_paid && (
          <RowItem
            label="Last paid"
            value={`${formatMoney(last_paid.amount_cents)} on ${formatDate(last_paid.issued_at)}`}
            href={`/portal/invoices/${last_paid.id}`}
          />
        )}
        {next_due && (
          <RowItem
            label="Next due"
            value={`${formatMoney(next_due.amount_cents)} by ${formatDate(next_due.due_at)}`}
            href={`/portal/invoices/${next_due.id}`}
          />
        )}
        {!last_paid && !next_due && (
          <div className="text-gray-500">No invoices yet.</div>
        )}
      </div>

      <Link
        to="/portal/invoices"
        className="mt-4 inline-flex items-center gap-1 text-[12px] text-gray-300 hover:text-white"
      >
        View all invoices <ArrowUpRight className="w-3 h-3" />
      </Link>
    </div>
  );
}

function RowItem({ label, value, href }) {
  return (
    <Link to={href} className="flex items-center justify-between hover:text-white">
      <span className="text-gray-500">{label}</span>
      <span className="text-gray-200">{value}</span>
    </Link>
  );
}
